module.exports = __webpack_public_path__ + "img/cameraVideo_c.430a7377.svg";